import React, { useState } from "react";
import axios from "axios";
import ReactAnimatedWeather from "react-animated-weather";

const API_KEY = "47a20d4c8cb990efbd9f921f5042cc46";

const weatherIconMap = {
  "clear sky": "CLEAR_DAY",
  "few clouds": "PARTLY_CLOUDY_DAY",
  "scattered clouds": "CLOUDY",
  "broken clouds": "CLOUDY",
  "shower rain": "RAIN",
  "rain": "RAIN",
  "moderate rain": "RAIN",
  "light rain": "RAIN",
  "thunderstorm": "THUNDERSTORM",
  "snow": "SNOW",
  "mist": "FOG",
  "fog": "FOG",
};

function getIcon(description) {
  const lower = description.toLowerCase();
  for (const key in weatherIconMap) {
    if (lower.includes(key)) return weatherIconMap[key];
  }
  return "CLEAR_DAY";
}

function formatDateTime() {
  const now = new Date();
  const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const day = days[now.getDay()];
  const h = String(now.getHours()).padStart(2, "0");
  const m = String(now.getMinutes()).padStart(2, "0");
  return `${day} ${h}:${m}`;
}

function getForecastDay(offset) {
  const days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  const d = new Date();
  d.setDate(d.getDate() + offset);
  return days[d.getDay()];
}

export default function App() {
  const [city, setCity] = useState("");
  const [weather, setWeather] = useState(null);
  const [forecast, setForecast] = useState([]);
  const [error, setError] = useState("");

  function fetchWeather(cityName) {
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${API_KEY}&units=metric`;
    const forecastUrl = `https://api.openweathermap.org/data/2.5/forecast?q=${cityName}&appid=${API_KEY}&units=metric`;

    axios.get(url)
      .then((res) => {
        const data = res.data;
        setWeather({
          city: data.name,
          tempC: Math.round(data.main.temp),
          description: data.weather[0].description,
          humidity: data.main.humidity,
          wind: Math.round(data.wind.speed * 3.6),
          icon: getIcon(data.weather[0].description),
        });
        setError("");
      })
      .catch(() => {
        setError("City not found.");
        setWeather(null);
        setForecast([]);
      });

    axios.get(forecastUrl)
      .then((res) => {
        const daily = [];
        const seen = new Set();
        res.data.list.forEach((item) => {
          const date = item.dt_txt.split(" ")[0];
          if (!seen.has(date) && daily.length < 5) {
            seen.add(date);
            daily.push({
              temp: Math.round(item.main.temp),
              icon: getIcon(item.weather[0].description),
            });
          }
        });
        setForecast(daily.slice(1));
      })
      .catch(() => {});
  }

  function handleSearch(e) {
    e.preventDefault();
    if (city.trim()) fetchWeather(city);
  }

  function handleCurrent() {
    navigator.geolocation.getCurrentPosition((pos) => {
      const { latitude, longitude } = pos.coords;
      const url = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${API_KEY}&units=metric`;
      axios.get(url).then((res) => {
        fetchWeather(res.data.name);
        setCity(res.data.name);
      });
    });
  }

  const shortcuts = ["Lisbon", "Paris", "Sydney", "San Francisco"];

  return (
    <div style={{ maxWidth: 480, margin: "30px auto", fontFamily: "sans-serif", padding: "0 16px" }}>

      <div style={{ display: "flex", gap: 16, marginBottom: 12 }}>
        {shortcuts.map((s) => (
          <span
            key={s}
            onClick={() => { setCity(s); fetchWeather(s); }}
            style={{ cursor: "pointer", color: "#007bff", fontSize: 14 }}
          >
            {s}
          </span>
        ))}
      </div>

      <form onSubmit={handleSearch} style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        <input
          type="text"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="Enter a city"
          style={{ flex: 1, padding: "10px 14px", fontSize: 15, border: "1px solid #ccc", borderRadius: 4 }}
        />
        <button type="submit" style={{ padding: "10px 18px", background: "#007bff", color: "#fff", border: "none", borderRadius: 4, fontSize: 15, cursor: "pointer" }}>
          Search
        </button>
        <button type="button" onClick={handleCurrent} style={{ padding: "10px 18px", background: "#28a745", color: "#fff", border: "none", borderRadius: 4, fontSize: 15, cursor: "pointer" }}>
          Current
        </button>
      </form>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {weather && (
        <div style={{ border: "1px solid #eee", borderRadius: 8, padding: 20 }}>
          <h2 style={{ margin: "0 0 4px", fontSize: 22 }}>{weather.city}</h2>
          <p style={{ margin: "0 0 2px", color: "#666", fontSize: 14 }}>{formatDateTime()}</p>
          <p style={{ margin: "0 0 16px", color: "#666", fontSize: 14, textTransform: "capitalize" }}>{weather.description}</p>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <ReactAnimatedWeather icon={weather.icon} color="goldenrod" size={60} animate={true} />
              <span style={{ fontSize: 60, fontWeight: 300 }}>{weather.tempC}</span>
              <span style={{ fontSize: 20, color: "#555", alignSelf: "flex-start", marginTop: 8 }}>°C</span>
            </div>
            <div style={{ textAlign: "right", color: "#555", fontSize: 14 }}>
              <p style={{ margin: "0 0 4px" }}>Precipitation: {weather.humidity}%</p>
              <p style={{ margin: 0 }}>Wind: {weather.wind}km/h</p>
            </div>
          </div>

          {forecast.length > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24, borderTop: "1px solid #eee", paddingTop: 16 }}>
              {forecast.map((day, i) => (
                <div key={i} style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 13, color: "#666", marginBottom: 6 }}>{getForecastDay(i + 1)}</div>
                  <ReactAnimatedWeather icon={day.icon} color="#555" size={28} animate={false} />
                  <div style={{ fontSize: 13, marginTop: 4 }}>{day.temp}°</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <p style={{ marginTop: 32, fontSize: 12, color: "#aaa", textAlign: "center" }}>
        Open-source code, by <strong>May Phoo Pyae San</strong> from She Codes —{" "}
        <a href="https://github.com/MayPhooPyaeSan/week6" target="_blank" rel="noreferrer">GitHub</a>
        {" | "}
        <a href="https://week5wweather.netlify.app" target="_blank" rel="noreferrer">Netlify</a>
      </p>
    </div>
  );
}